import type { ButtonFormItem, FormItemDefinition } from 'types';
import { CHANGE_BEHAVIOR_OPTION } from 'types/enums';

export interface FormItemWithChangeBehavior {
  changeBehavior?: CHANGE_BEHAVIOR_OPTION;
}

export const isFormItemWithChangeBehavior = (item: unknown): item is FormItemWithChangeBehavior => {
  return typeof item === 'object' && item !== null && 'changeBehavior' in item;
};

export const hasCalculateBehavior = (definition: FormItemDefinition, defKey: keyof FormItemDefinition): boolean => {
  const itemDef = definition[defKey];
  return isFormItemWithChangeBehavior(itemDef) && itemDef.changeBehavior === CHANGE_BEHAVIOR_OPTION.CALCULATE;
};

export const getChangeBehavior = (definition: FormItemDefinition, defKey: keyof FormItemDefinition): CHANGE_BEHAVIOR_OPTION | undefined => {
  const itemDef = definition[defKey];
  return isFormItemWithChangeBehavior(itemDef) ? itemDef.changeBehavior : undefined;
};

export const getButtonFormDefinition = (definition: FormItemDefinition, defKey: keyof FormItemDefinition) => {
  const { name } = (definition[defKey] ?? {}) as ButtonFormItem;

  return {
    changeBehavior: getChangeBehavior(definition, defKey),
    name,
  };
};
